var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "farelanes-loader",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .loader-arc {\n                fill: none;\n                stroke: #006838;\n                stroke-width: 4;\n                stroke-linecap: round;\n            }\n            .loader-track {\n                fill: none;\n                stroke: #006838;\n                stroke-width: 4;\n                opacity: 0.2;\n            }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "loader-track",
    cx: 25,
    cy: 25,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "loader-arc",
    d: "M 25 5 A 20 20 0 0 1 45 25",
    strokeDasharray: "30 100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.720322ef38064e6a174f4bf9eea9ce6b.svg";
export { ForwardRef as ReactComponent };